import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ICurrencyInfo, MoneyService } from 'i2g-ng-utils';

@Pipe({
  name: 'removeCurrencySymbol',
})
export class RemoveCurrencySymbolPipe implements PipeTransform {
  constructor(private _moneyService: MoneyService) {}

  transform(value: any, currencyCode = 'USD', locale = 'en_US'): any {
    if (value instanceof Observable) {
      return value.pipe(
        map((v) => this._removeCurrencySymbol(v, currencyCode, locale))
      );
    } else {
      return this._removeCurrencySymbol(value, currencyCode, locale);
    }
  }

  private _removeCurrencySymbol(
    value: string,
    currencyCode: string,
    locale: string
  ): string {
    const currencyInfo: ICurrencyInfo = this._moneyService.getCurrencyInfo(
      currencyCode
    );

    try {
      const formattedNumber = new Intl.NumberFormat(locale, {
        style: 'decimal',
        maximumFractionDigits: currencyInfo.decimalDigits || 2,
        minimumFractionDigits: currencyInfo.decimalDigits || 2,
      }).format(1000);

      const formattedCurrency = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: currencyInfo.decimalDigits || 2,
        minimumFractionDigits: currencyInfo.decimalDigits || 2,
      }).format(1000);

      const currencySymbol = formattedCurrency.replace(formattedNumber, '');
      return value.replace(currencySymbol, '');
    } catch (e) {
      return value;
    }
  }
}
